import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { adminGetGifts, isOk, messageOf } from "../../../services/gift";
import AdminGiftSettings from "./settings";
import "./admin-gifts.css";

export const GIFT_STATUSES = [
  { value: "", label: "All statuses" },
  { value: "pending_payment", label: "Fee not paid" },
  { value: "active", label: "Active" },
  { value: "payment_pending", label: "Booked — awaiting purchaser payment" },
  { value: "redeemed", label: "Redeemed" },
  { value: "suspended", label: "Suspended" },
  { value: "disabled", label: "Disabled" },
  { value: "awaiting_purchaser", label: "Reservation expired — awaiting purchaser's answer" },
  { value: "withdrawn", label: "Cancelled / closed by giver" },
  { value: "expired", label: "Expired" },
  { value: "abandoned", label: "Abandoned checkout" },
];

export const statusLabel = (status) => {
  const found = GIFT_STATUSES.find((item) => item.value === status);
  return found ? found.label : status;
};

const formatDate = (iso) => (iso ? new Date(iso).toLocaleString() : "—");

// Admin: VerySoul Gifts list. Shows the code's last 4 only, never the Gift Word.
export default function AdminGifts() {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [page, setPage] = useState(1);
  const [result, setResult] = useState({ gifts: [], total: 0, last_page: 1 });
  const [loading, setLoading] = useState(false);

  const load = (nextPage = page) => {
    setLoading(true);
    adminGetGifts({ search, status, page: nextPage, per_page: 20 }).then((res) => {
      setLoading(false);
      if (isOk(res)) {
        setResult(res.data.data);
        setPage(res.data.data.current_page);
      } else {
        toast.error(messageOf(res, "Gifts could not be loaded."), { position: "top-center" });
      }
    });
  };

  useEffect(() => {
    load(1);
  }, [status]);

  return (
    <div className="admin-gifts">
      <AdminGiftSettings />
      <div className="admin-gifts-toolbar">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            load(1);
          }}
        >
          <input
            className="form-control"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Purchaser email, GIFT-123, full code or last 4"
          />
          <button type="submit" className="proceed-btn">
            Search
          </button>
        </form>
        <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
          {GIFT_STATUSES.map((item) => (
            <option key={item.value} value={item.value}>
              {item.label}
            </option>
          ))}
        </select>
        <Link to="/gift-blocks" className="admin-gifts-link">
          Blocked purchasers
        </Link>
      </div>

      <div className="table-box-medium admin-appoi admin-upcoming-app mt-3">
        <table className="caseTable">
          <tbody>
            <tr className="dark">
              <th>Reference</th>
              <th>Code</th>
              <th>Purchaser</th>
              <th>Covers up to</th>
              <th>Status</th>
              <th>Latest booking</th>
              <th>Created</th>
              <th>Expires</th>
            </tr>
            {result.gifts.map((gift) => (
              <tr key={gift.id} className="innr-dark">
                <td>
                  <Link to={`/gifts/${gift.id}`}>{gift.reference}</Link>
                </td>
                <td>{gift.code_last4 ? `…${gift.code_last4}` : "—"}</td>
                <td>
                  {gift.purchaser_name || ""}
                  <br />
                  <span className="admin-gifts-muted">{gift.purchaser_email}</span>
                </td>
                <td>
                  {gift.currency} {gift.max_price}
                </td>
                <td>
                  <span className={`admin-gift-status status-${gift.status}`}>{statusLabel(gift.status)}</span>
                </td>
                <td>
                  {gift.latest_redemption ? (
                    <>
                      {gift.latest_redemption.status} &middot; {gift.latest_redemption.recipient_email}
                    </>
                  ) : (
                    "—"
                  )}
                </td>
                <td>{formatDate(gift.created_at)}</td>
                <td>{formatDate(gift.expires_at)}</td>
              </tr>
            ))}
            {!loading && result.gifts.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center">
                  No gifts found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="admin-gifts-pager">
        <button type="button" className="proceed-btn" disabled={page <= 1 || loading} onClick={() => load(page - 1)}>
          Previous
        </button>
        <span>
          Page {page} of {result.last_page || 1} &middot; {result.total} gifts
        </span>
        <button type="button" className="proceed-btn" disabled={page >= (result.last_page || 1) || loading} onClick={() => load(page + 1)}>
          Next
        </button>
      </div>
    </div>
  );
}
